import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

const pagesArr = ['info', 'listing'];

@Component({
  selector: 'mj-blog-navigation',
  templateUrl: './blog-navigation.component.html',
  styleUrls: ['./blog-navigation.component.scss'],
})
export class BlogNavigationComponent implements OnInit {
  currentRoute;
  routeSub$: Subscription;
  isAdding;
  @Input() isBlogInfoValid: boolean;
  @Input() isBlogListingValid: boolean;
  @Input() pendingRequest: boolean;
  @Output() cancelButtonClicked = new EventEmitter<any>();
  @Output() nextStepClicked = new EventEmitter<any>();

  @Output() saveBlogClicked = new EventEmitter<any>();
  @Output() updateBlogClicked = new EventEmitter<any>();

  constructor(private _router: Router) {}

  ngOnInit() {
    this.isAdding = this._router.url.indexOf('add') !== -1;
    this.watchRoutes();
  }

  isBlogValid() {
    return (
      (this.currentRoute === 'info' && this.isBlogInfoValid) ||
      (this.currentRoute === 'listing' && this.isBlogListingValid)
    );
  }

  watchRoutes() {
    const getCurrentRoute = () => {
      const routeArr = this._router.url.split('/');
      this.currentRoute = routeArr[routeArr.length - 1];
    };

    getCurrentRoute();

    this.routeSub$ = this._router.events.subscribe(ev => {
      if (ev instanceof NavigationEnd) {
        getCurrentRoute();
      }
    });
  }

  goToStep(step: string) {
    this.nextStepClicked.emit(step);
  }

  goToPreviousStep() {
    const newRoute = pagesArr[pagesArr.indexOf(this.currentRoute) - 1];
    if (!newRoute) {
      return;
    }
    this.goToStep(newRoute);
  }

  cancelButtonPressed() {
    this.cancelButtonClicked.emit();
  }

  getStep(page: number) {
    const isDone = page < pagesArr.indexOf(this.currentRoute);
    const isActive = this.currentRoute === pagesArr[page];
    const classes = `${isDone ? 'done' : isActive ? 'active' : ''}`;
    return classes;
  }

  goToStepIfPossible(step: number) {}

  goToNextStep() {
    const newRoute = pagesArr[pagesArr.indexOf(this.currentRoute) + 1];
    if (!newRoute) {
      return;
    }
    this.goToStep(newRoute);
  }

  shouldBeShownAsPopUp() {
    return !this.isAdding;
  }

  saveBlogPressed() {
    this.saveBlogClicked.emit();
  }

  updateBlogPressed() {
    this.updateBlogClicked.emit();
  }
}
